import type { ReactElement } from 'react';
import { dataEl, type DataElScope } from '@/utils/dataEl';
import { POPOVER_RESIZE_CURSOR, POPOVER_RESIZE_HANDLE_SIZE, TABLE_STYLE_VALUE, } from './Cmarkdowntable.constants';
import type { TablePopoverPointerHandler } from './Cmarkdowntable.types';
interface CmarkdowntablePopoverResizeHandleProps {
    dataElScope: DataElScope;
    onResizePointerDown: TablePopoverPointerHandler;
    onResizePointerMove: TablePopoverPointerHandler;
    onResizePointerEnd: TablePopoverPointerHandler;
}
export function CmarkdowntablePopoverResizeHandle({ dataElScope, onResizePointerDown, onResizePointerMove, onResizePointerEnd, }: CmarkdowntablePopoverResizeHandleProps): ReactElement {
    return (
      <div data-el={dataEl(dataElScope, 'PopoverResizeHandle/Root')} onPointerDown={onResizePointerDown} onPointerMove={onResizePointerMove} onPointerUp={onResizePointerEnd} onPointerCancel={onResizePointerEnd} aria-hidden style={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: POPOVER_RESIZE_HANDLE_SIZE,
            height: POPOVER_RESIZE_HANDLE_SIZE,
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            padding: 3,
            cursor: POPOVER_RESIZE_CURSOR,
            touchAction: TABLE_STYLE_VALUE.TouchActionNone,
        }}>
          <svg width="9" height="9" viewBox="0 0 9 9" fill="none" aria-hidden>
            <path d="M8.5 1.5 L1.5 8.5 M8.5 5 L5 8.5" stroke="rgba(255,255,255,0.4)" strokeWidth="1.2" strokeLinecap="round"/>
          </svg>
      </div>
    );
}
